<!-- 关注后回复的模板 -->
<template>
  <div>
    <div
      v-for="(big_tem, big_index) in gzhTabData"
      style="
        border: 1px solid #dfdfdf;
        padding: 25px;
        margin-bottom: 30px;
        background-color: #f2f3f5;
      "
    >
      <div class="form-cell-box">
        <div
          v-if="page_type == 'follow' || page_type == 'contact'"
          class="class-title"
        >
          消息名称
        </div>
        <div v-else-if="page_type == 'keyWord'" class="class-title">关键词</div>

        <a-input
          v-model="big_tem.contentData.e_title"
          @blur="campaignNameBlur($event, big_index, 1)"
          ref="focusA"
          placeholder="请输入消息名称"
          :style="{ width: modal_width + 'px' }"
        />
      </div>

      <div v-if="page_type == 'follow'" class="form-cell-box">
        <div class="class-title">推送时机</div>
        <div style="display: inline-block; align-items: center">
          <span>用户关注后</span>
          <a-input-number
            :min="0"
            :max="55"
            v-model="big_tem.contentData.e_send_time"
            style="width: 70px; margin: 0 10px"
          />
          <span>秒</span>
          <span style="font-size: 12px; color: #bbb; margin-left: 15px"
            >最小0秒，最大55秒</span
          >
        </div>
      </div>
      <div v-if="page_type == 'contact'" class="form-cell-box">
        <div class="class-title">推送时机</div>
        <div style="display: inline-block; align-items: center">
          <span>用户互动后</span>
          <a-input-number
            :min="1"
            :max="2879"
            v-model="big_tem.contentData.e_send_time"
            style="width: 70px; margin: 0 10px"
          />
          <span>分钟</span>
          <span style="font-size: 13px; color: #b5b3b3; margin-left: 15px"
            >说明：可以填写 1 到 2879 分钟</span
          >
        </div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">消息类型</div>
        <!-- <div >
          <a-radio-group
            @change="messTypeA($event, big_tem)"
            name="radioGroup"
            :value="big_tem.contentData.e_type"
          >
            <a-radio :value="1">文本消息</a-radio>
            <a-radio :value="2">图片消息</a-radio>
            <a-radio :value="5">小程序卡片</a-radio>
          </a-radio-group>
        </div> -->
        <div>
          <a-radio-group
            @change="messTypeA($event, big_tem)"
            name="radioGroup"
            :value="big_tem.contentData.e_type"
          >
            <a-radio :value="1">文本消息</a-radio>
            <a-radio :value="2">图片消息</a-radio>
            <a-radio :value="3" v-if="set_type === 'h5'">单条图文消息</a-radio>
            <a-radio
              v-if="page_type == 'follow' && set_type === 'h5'"
              :value="4"
              >多条图文消息</a-radio
            >
            <a-radio :value="5" v-if="set_type === 'mini'">小程序卡片</a-radio>
          </a-radio-group>
        </div>
      </div>

      <div
        v-if="big_tem.contentData.e_type == 1"
        class="form-cell-box"
        style="align-items: flex-start"
      >
        <div class="class-title">文本消息内容</div>
        <div>
          <a-textarea
            v-model="big_tem.contentData.e_text_content"
            placeholder="请输入文本消息内容"
            :auto-size="{ minRows: 14, maxRows: 25 }"
            :style="{ width: modal_width + 'px' }"
            @blur="campaignNameBlur($event, big_index, 2)"
            ref="focusB"
          />
          <!-- <pre type="text" style="flex: 1 1 0%;padding: 0.25em 0.5em;height: 100%;line-height: 1.5;overflow-wrap: break-word;overflow: hidden scroll;text-align: left;white-space: pre-wrap;">
				亲爱的用户，请按下方提示继续阅读「🔥宋小书」
				🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
				🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
				点击左下角的“⌨️”↙↙↙即可【回复数字】
				</pre> -->
        </div>
      </div>

      <div v-if="big_tem.contentData.e_type == 2" class="form-cell-box">
        <div class="class-title">图片</div>

        <a-upload
          accept="image/*"
          name="file"
          class="avatar-uploader"
          :show-upload-list="false"
          :action="`${$http.excel_url}api/common/upload-image`"
          :data="{
            type: 5,
          }"
          :headers="{
            Authorization: headers_token,
          }"
          :withCredentials="true"
          method="post"
          :before-upload="beforeUpload"
          @change="uploadChange($event, big_index)"
        >
          <div
            style="border: 1px dashed #d9d9d9; cursor: pointer; width: 300px"
          >
            <img
              v-if="big_tem.contentData.e_img_url"
              :src="big_tem.contentData.e_img_url"
              style="width: 100%; height: 150px; object-fit: contain"
              alt=""
            />
            <div
              v-else
              style="
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #999;
              "
            >
              <div style="text-align: center">
                <a-icon
                  :type="e_img_loading ? 'loading' : 'plus'"
                  style="font-size: 22px"
                />
                <div>图片上传</div>
              </div>
            </div>
          </div>
        </a-upload>
      </div>

      <div v-if="big_tem.contentData.e_type == 3" class="form-cell-box">
        <div class="class-title">消息标题</div>
        <a-input
          v-model="big_tem.contentData.e_txtImg_title"
          @blur="campaignNameBlur($event, big_index, 3)"
          ref="focusC"
          placeholder="请输入消息标题"
          :style="{ width: modal_width + 'px' }"
        />
      </div>
      <div v-if="big_tem.contentData.e_type == 3" class="form-cell-box">
        <div class="class-title">消息描述</div>
        <a-input
          v-model="big_tem.contentData.e_txtImg_description"
          @blur="campaignNameBlur($event, big_index, 4)"
          ref="focusD"
          placeholder="请输入消息描述"
          :style="{ width: modal_width + 'px' }"
        />
      </div>
      <div v-if="big_tem.contentData.e_type == 3" class="form-cell-box">
        <div class="class-title">消息图片</div>
        <div style="border: 1px dashed #d9d9d9; cursor: pointer; width: 150px">
          <a-upload
            accept="image/*"
            name="file"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/common/upload-image`"
            :data="{
              type: 5,
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="txtimgBeforeUpload"
            @change="txtimgUploadChange($event, big_index)"
          >
            <div
              class="type-3"
              style="
                border: 1px dashed #d9d9d9;
                cursor: pointer;
                width: 150px;
                position: relative;
              "
            >
              <img
                v-if="big_tem.contentData.e_txtImg_image"
                :src="big_tem.contentData.e_txtImg_image"
                style="width: 100%; height: 150px; object-fit: contain"
                alt=""
              />
              <div
                v-else
                style="
                  height: 150px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #999;
                "
              >
                <div style="text-align: center">
                  <a-icon
                    :type="e_img_loading ? 'loading' : 'plus'"
                    style="font-size: 22px"
                  />
                  <div>图片上传</div>
                </div>
              </div>

              <div
                v-if="big_tem.contentData.e_txtImg_image"
                class="cover-handle"
              >
                <div
                  @click.stop="cutCover(big_tem, big_index)"
                  style="color: #fff; text-align: center; cursor: pointer"
                >
                  <a-icon style="font-size: 18px" type="scissor" />
                  <div>裁剪封面</div>
                </div>
                <div style="color: #fff; text-align: center; cursor: pointer">
                  <a-icon style="font-size: 18px" type="swap" />
                  <div>更换封面</div>
                </div>
              </div>
            </div>
          </a-upload>
        </div>
      </div>
      <div v-if="big_tem.contentData.e_type == 3" class="form-cell-box">
        <div class="class-title">消息链接URL</div>
        <a-input
          v-model="big_tem.contentData.e_txtImg_url"
          @blur="campaignNameBlur($event, big_index, 5)"
          ref="focusE"
          placeholder="请输入消息链接URL"
          :style="{ width: modal_width + 'px' }"
        />
      </div>

      <div
        v-if="big_tem.contentData.e_type == 4"
        style="
          background-color: #f7f8fa;
          padding: 20px 15px;
          margin-bottom: 20px;
          margin-left: -15px;
          margin-right: -15px;
        "
      >
        <div class="form-cell-box" style="margin-bottom: 0">
          <div class="class-title">多条图文内容</div>
          <div style="display: flex; flex: 1">
            <div style="border: 1px solid #999; width: 300px; padding: 20px">
              <div
                v-for="(item, index) in big_tem.contentData.e_txtImgData"
                :key="index"
              >
                <!-- 第一个素材-大图显示 -->
                <div
                  v-if="index == 0"
                  @click="changeMaterial(item, 0, big_tem)"
                  style="pointer-events: all"
                  class="left-cell-top"
                  :class="[
                    big_tem.contentData.e_txtImgData[0].select_status
                      ? 'left-box-border'
                      : '',
                  ]"
                >
                  <a-popover placement="right">
                    <template slot="content">
                      <div
                        style="cursor: pointer"
                        @click="confirmDelImg(0, big_tem)"
                      >
                        删除
                      </div>
                    </template>
                    <img
                      v-if="big_tem.contentData.e_txtImgData[0].image"
                      style="width: 100%; height: 120px"
                      :src="big_tem.contentData.e_txtImgData[0].image"
                      alt=""
                    />
                    <div
                      v-else
                      style="width: 100%; height: 120px; border: 1px solid #ccc"
                    ></div>
                  </a-popover>

                  <div class="left-top-title">
                    {{ big_tem.contentData.e_txtImgData[0].title || "标题" }}
                  </div>
                </div>
                <!-- 第一个后面的素材 -->
                <a-popover placement="right">
                  <template slot="content">
                    <div
                      style="cursor: pointer"
                      @click="confirmDelImg(index, big_tem)"
                    >
                      删除
                    </div>
                  </template>
                  <div
                    v-if="index > 0"
                    @click="changeMaterial(item, index, big_tem)"
                    class="left-cell-box"
                    :class="[
                      item.select_status
                        ? 'left-box-border'
                        : 'left-cell-box-boder',
                    ]"
                    style="pointer-events: all"
                  >
                    <div style="flex: 1">{{ item.title || "标题" }}</div>
                    <img
                      v-if="item.image"
                      class="left-cell-img"
                      :src="item.image"
                      alt=""
                    />
                    <div
                      v-else
                      class="left-cell-img"
                      style="border: 1px solid #ccc"
                    ></div>
                  </div>
                </a-popover>
              </div>

              <div @click="addContent(big_tem)" class="left-cell-add" style="">
                + 新建素材
              </div>
            </div>
            <div style="margin-left: 25px; flex: 1">
              <div class="msg-cell-title">消息标题</div>
              <a-input
                v-model="
                  big_tem.contentData.e_txtImgData[
                    big_tem.contentData.e_txtImg_index
                  ].title
                "
                @blur="campaignNameBlur($event, big_index, 6)"
                ref="focusF"
                placeholder="请输入消息标题"
              />

              <div class="msg-cell-title" style="margin-top: 20px">
                消息描述
              </div>
              <!-- <span style="font-size: 12px;color: #bbb;margin-left: 15px;">可以不填，默认为标题</span> -->
              <a-input
                v-model="
                  big_tem.contentData.e_txtImgData[
                    big_tem.contentData.e_txtImg_index
                  ].description
                "
                @blur="campaignNameBlur($event, big_index, 7)"
                ref="focusG"
                placeholder="请输入消息描述"
              />

              <div class="msg-cell-title" style="margin-top: 20px">
                消息图片
              </div>
              <!-- <div style="border:1px dashed #d9d9d9;cursor: pointer;width: 200px;"> -->
              <a-upload
                accept="image/*"
                name="file"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="`${$http.excel_url}api/common/upload-image`"
                :data="{
                  type: 5,
                }"
                :headers="{
                  Authorization: headers_token,
                }"
                :withCredentials="true"
                method="post"
                :before-upload="txtimgBeforeUpload"
                @change="txtimgUploadChange($event, big_index)"
              >
                <div
                  class="cover-box"
                  style="
                    border: 1px dashed #d9d9d9;
                    width: 200px;
                    position: relative;
                  "
                >
                  <img
                    v-if="
                      big_tem.contentData.e_txtImgData[
                        big_tem.contentData.e_txtImg_index
                      ].image
                    "
                    :src="
                      big_tem.contentData.e_txtImgData[
                        big_tem.contentData.e_txtImg_index
                      ].image
                    "
                    style="width: 100%; height: 100px; object-fit: contain"
                    alt=""
                  />
                  <div
                    v-else
                    style="
                      height: 100px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #999;
                      cursor: pointer;
                    "
                  >
                    <div style="text-align: center">
                      <a-icon
                        :type="e_img_loading ? 'loading' : 'plus'"
                        style="font-size: 22px"
                      />
                      <div>图片上传</div>
                    </div>
                  </div>

                  <div
                    v-if="
                      big_tem.contentData.e_txtImgData[
                        big_tem.contentData.e_txtImg_index
                      ].image
                    "
                    class="cover-handle"
                  >
                    <div
                      @click.stop="cutCover(big_tem, big_index)"
                      style="color: #fff; text-align: center; cursor: pointer"
                    >
                      <a-icon style="font-size: 18px" type="scissor" />
                      <div>裁剪封面</div>
                    </div>
                    <div
                      style="color: #fff; text-align: center; cursor: pointer"
                    >
                      <a-icon style="font-size: 18px" type="swap" />
                      <div>更换封面</div>
                    </div>
                  </div>
                </div>
              </a-upload>
              <!-- </div> -->

              <div class="msg-cell-title" style="margin-top: 20px">
                消息链接URL
              </div>
              <a-input
                v-model="
                  big_tem.contentData.e_txtImgData[
                    big_tem.contentData.e_txtImg_index
                  ].url
                "
                @blur="campaignNameBlur($event, big_index, 8)"
                ref="focusH"
                placeholder="请输入消息链接URL"
              />
            </div>
          </div>
        </div>
      </div>
      <template v-if="big_tem.contentData.e_type == 5">
        <div class="form-cell-box">
          <div class="class-title">小程序标题</div>
          <a-input
            v-model="big_tem.contentData.xcx_title"
            @blur="campaignNameBlur($event, big_index, 9)"
            ref="focusI"
            placeholder="请输入小程序标题"
            :style="{ width: modal_width + 'px' }"
          />
        </div>
        <div class="form-cell-box">
          <div class="class-title">小程序APPID</div>
          <a-input
            v-model="big_tem.contentData.xcx_appid"
            @blur="campaignNameBlur($event, big_index, 10)"
            ref="focusJ"
            placeholder="请输入小程序APPID"
            :style="{ width: modal_width + 'px' }"
          />
        </div>
        <div class="form-cell-box">
          <div class="class-title">小程序路径</div>
          <a-input
            v-model="big_tem.contentData.xcx_pagepath"
            @blur="campaignNameBlur($event, big_index, 11)"
            ref="focusK"
            placeholder="请输入小程序路径"
            :style="{ width: modal_width + 'px' }"
          />
        </div>
        <div class="form-cell-box">
          <div class="class-title">消息封面</div>
          <div
            style="border: 1px dashed #d9d9d9; cursor: pointer; width: 150px"
          >
            <a-upload
              accept="image/*"
              name="file"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="`${$http.excel_url}api/common/upload-image`"
              :data="{
                type: 5,
              }"
              :headers="{
                Authorization: headers_token,
              }"
              :withCredentials="true"
              method="post"
              :before-upload="txtimgBeforeUpload"
              @change="txtimgUploadChange($event, big_index)"
            >
              <div
                class="type-3"
                style="
                  border: 1px dashed #d9d9d9;
                  cursor: pointer;
                  width: 150px;
                  position: relative;
                "
              >
                <img
                  v-if="big_tem.contentData.xcx_media_url"
                  :src="big_tem.contentData.xcx_media_url"
                  style="width: 100%; height: 150px; object-fit: contain"
                  alt=""
                />
                <div
                  v-else
                  style="
                    height: 150px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #999;
                  "
                >
                  <div style="text-align: center">
                    <a-icon
                      :type="e_img_loading ? 'loading' : 'plus'"
                      style="font-size: 22px"
                    />
                    <div>图片上传</div>
                  </div>
                </div>

                <div
                  v-if="big_tem.contentData.xcx_media_url"
                  class="cover-handle"
                >
                  <div
                    @click.stop="cutCover(big_tem, big_index)"
                    style="color: #fff; text-align: center; cursor: pointer"
                  >
                    <a-icon style="font-size: 18px" type="scissor" />
                    <div>裁剪封面</div>
                  </div>
                  <div style="color: #fff; text-align: center; cursor: pointer">
                    <a-icon style="font-size: 18px" type="swap" />
                    <div>更换封面</div>
                  </div>
                </div>
              </div>
            </a-upload>
          </div>
        </div>
      </template>

      <!-- <div class="form-cell-box">
			<div class="class-title">开启状态</div>
			<a-switch :checked="big_tem.contentData.e_switch" checked-children="开启" un-checked-children="关闭" @change="addStatusChange($event)" />
		</div> -->

      <div style="text-align: right; margin-top: 15px">
        <a-button @click="delFollow(big_index)" type="danger">删除</a-button>
      </div>
    </div>

    <div style="border: 1px solid #dfdfdf; padding: 25px; display: flex">
      <div @click="addFollow" v-if="page_type == 'follow'" class="add-button">
        添加关注后回复
      </div>
      <div
        @click="addFollow"
        v-else-if="page_type == 'keyWord'"
        class="add-button"
      >
        添加关键词回复
      </div>
      <div
        @click="addFollow"
        v-else-if="page_type == 'contact'"
        class="add-button"
      >
        添加延迟客服消息
      </div>
    </div>

    <cropperImgModal
      ref="getCropperImg"
      @cropper-ok="cropperOk"
    ></cropperImgModal>
  </div>
</template>

<script>
import cropperImgModal from "../components/cropperImgModal.vue";
export default {
  name: "followTmp_",
  props: ["page_type", "handle_type", "set_type"],
  components: {
    cropperImgModal,
  },
  data() {
    return {
      gzhData: [], // 公众号分组的数据
      gzhTabData: [
        {
          // gzh_name: null,
          contentData: {
            e_title: "", // 消息名称
            e_send_time: 0, // 推送时机
            e_type: 1, // 消息类型
            e_switch: false, // 开启状态

            e_text_content: "", // 文本消息

            e_img_url: "", // 图片消息，的图片链接
            e_img_media_id: "", // 图片消息，的media_id

            e_txtImg_title: "", // 单图文消息 - 标题
            e_txtImg_description: "", // 单图文消息 - 描述
            e_txtImg_url: "", // 单图文消息 -  跳转链接
            e_txtImg_image: "", // 单图文消息 - 图片oss
            e_txtImg_path: "", // 单图文消息 - 图片地址

            e_txtImgData: [
              {
                select_status: true,
                title: "",
                description: "",
                url: "",
                image: "",
              },
            ], // 多图文素材
            e_txtImg_index: 0,

            xcx_title: "",
            xcx_appid: "",
            xcx_pagepath: "",
            xcx_media_url: "",
            xcx_media_id: "",
          },
        },
      ], // tab栏的公众号
      gzh_tab_index: 0, // 当前选中公众号tab的索引

      edit_id: null,

      gzh_list_top: 41,

      modal_search_loading: false,

      headers_token: "", // 图片上传用的token

      modal_width: 600, // 输入框宽度
      e_openid: "",

      e_img_loading: false,
      msg_preview_loading: false,

      campaignNameIndex: 0, // 光标在文本中的位置
      campaign_type: 0, // 用于判断是哪个输入框要插入文本
    };
  },
  mounted() {
    // 图片上传用的token
    this.headers_token = "Bearer " + localStorage.getItem("access_token");
  },
  methods: {
    // 获取详情-公众号配置模板
    getInfoTempalet(data) {
      let that = this;
      // console.log("获取详情-公众号配置模板", data);
      let arr = [];
      let ddd = {
        // gzh_name: null,
        contentData: {
          e_title: "", // 消息名称
          e_send_time: 0, // 推送时机
          e_type: 1, // 消息类型
          e_switch: false, // 开启状态

          e_text_content: "", // 文本消息

          e_img_url: "", // 图片消息，的图片链接
          e_img_media_id: "", // 图片消息，的media_id

          e_txtImg_title: "", // 单图文消息 - 标题
          e_txtImg_description: "", // 单图文消息 - 描述
          e_txtImg_url: "", // 单图文消息 -  跳转链接
          e_txtImg_image: "", // 单图文消息 - 图片oss
          e_txtImg_path: "", // 单图文消息 - 图片地址

          e_txtImgData: [
            {
              select_status: true,
              title: "",
              description: "",
              url: "",
              image: "",
            },
          ], // 多图文素材
          e_txtImg_index: 0,

          xcx_title: "",
          xcx_appid: "",
          xcx_pagepath: "",
          xcx_media_url: "",
          xcx_media_id: "",
        },
      };
      for (let i = 0; i < data.length; i++) {
        arr.push(JSON.parse(JSON.stringify(ddd)));
      }
      arr.forEach((res, index) => {
        if (that.page_type == "keyWord") {
          res.contentData.e_title = data[index].keyword;
        } else {
          res.contentData.e_title = data[index].title;
        }

        if (that.page_type == "contact") {
          res.contentData.e_send_time = data[index].send_time || 1;
        } else {
          res.contentData.e_send_time = data[index].send_time || 0;
        }

        res.contentData.e_type = data[index].type;

        if (data[index].type == 1) {
          res.contentData.e_text_content = decodeURIComponent(
            data[index].content.content
          );
        } else if (data[index].type == 2) {
          res.contentData.e_img_url = data[index].content.media_id_url;
          res.contentData.e_img_media_id = data[index].content.media_id || "";
        } else if (data[index].type == 3) {
          res.contentData.e_txtImg_title = data[index].content.title;
          res.contentData.e_txtImg_description =
            data[index].content.description;
          res.contentData.e_txtImg_url = data[index].content.url;
          res.contentData.e_txtImg_image = data[index].content.image;
          res.contentData.e_txtImg_path = "";
        } else if (data[index].type == 4) {
          res.contentData.e_txtImgData = data[index].content;
        } else if (data[index].type == 5) {
          // 小程序
          res.contentData.xcx_title = data[index].content.title;
          res.contentData.xcx_appid = data[index].content.appid;
          res.contentData.xcx_pagepath = data[index].content.pagepath;
          // res.contentData.xcx_media_id = data[index].content.thumb_media_id // 可以不传
          res.contentData.xcx_media_url =
            data[index].content.thumb_media_id_url;
        }
      });
      this.gzhTabData = arr;
    },
    messTypeA(e, b_item) {
      console.log("切换 消息类型", e.target.value);
      // this.e_type = e.target.value
      // let that = this
      console.log("gzhTabData", this.gzhTabData);
      if (e.target.value == 4 && this.page_type == "follow") {
        let i = 0;
        this.gzhTabData.forEach((res) => {
          if (res.contentData.e_type == 4) {
            i = i + 1;
          }
        });
        if (i == 0) {
          b_item.contentData.e_type = e.target.value;
        } else {
          this.$message.warning("关注后回复-多条图文消息最多开启1条");
        }
      } else {
        b_item.contentData.e_type = e.target.value;
      }

      // this.$set( target, key, value )
    },

    // 新建消息弹窗操作按钮
    msgHandleOk() {
      let that = this;
      console.log("that.gzhTabData", that.gzhTabData);
      if (that.gzhTabData.length == 0) {
        that.$message.warning("内容不能为空");
        return;
      }

      let warning_text = this.set_type === "h5" ? "H5站-" : "小程序-";
      if (that.page_type == "follow") {
        warning_text = `${warning_text}关注后回复`;
      } else if (that.page_type == "keyWord") {
        warning_text = `${warning_text}关键词回复`;
      } else if (that.page_type == "contact") {
        warning_text = `${warning_text}延迟客服消息`;
      }

      let r_arr = [];
      const for_gzh = new Promise((resolve, reject) => {
        let r_number = 0;
        for (let i = 0; i < that.gzhTabData.length; i++) {
          if (!that.gzhTabData[i].contentData.e_title) {
            that.$message.warning(
              `${warning_text}---请填写${
                that.page_type == "keyWord" ? "关键词" : "消息名称"
              }`
            );
            break;
          } else {
            let r_data = {
              // gzh_id: that.gzhTabData[i].id,

              type: that.gzhTabData[i].contentData.e_type,
              // status: that.gzhTabData[i].contentData.e_switch? 1 : 0,

              content: {},
            };
            if (that.page_type == "follow") {
              r_data.title = that.gzhTabData[i].contentData.e_title;
              r_data.send_time =
                that.gzhTabData[i].contentData.e_send_time || 0;
            } else if (that.page_type == "contact") {
              // 客服消息
              r_data.title = that.gzhTabData[i].contentData.e_title;
              r_data.send_time =
                that.gzhTabData[i].contentData.e_send_time || 1;
            } else if (that.page_type == "keyWord") {
              r_data.keyword = that.gzhTabData[i].contentData.e_title;
            }

            let g_data = that.gzhTabData[i].contentData;
            if (g_data.e_type == 1) {
              // 文本消息
              if (!g_data.e_text_content) {
                that.$message.warning(`${warning_text}---请填写文本消息内容`);
                return;
              }

              r_data.content.content = encodeURIComponent(
                g_data.e_text_content
              );
              // console.log(that.handle_title)
              r_number = r_number + 1;
            } else if (g_data.e_type == 2) {
              // 图片消息
              if (!g_data.e_img_url) {
                that.$message.warning(`${warning_text}---缺少图片信息`);
                return;
              }
              r_data.content.media_id = g_data.e_img_media_id;
              r_data.content.media_id_url = g_data.e_img_url;

              r_number = r_number + 1;
            } else if (g_data.e_type == 3) {
              // 单图文消息
              if (!g_data.e_txtImg_title) {
                that.$message.warning(`${warning_text}---请填写消息标题`);
                return;
              } else if (!g_data.e_txtImg_description) {
                that.$message.warning(`${warning_text}---请填写消息描述`);
                return;
              } else if (!g_data.e_txtImg_url) {
                that.$message.warning(`${warning_text}---请上传消息链接`);
                return;
              } else if (!g_data.e_txtImg_image) {
                that.$message.warning(`${warning_text}---请填写消息图片`);
                return;
              }
              r_data.content.title = g_data.e_txtImg_title;
              r_data.content.description = g_data.e_txtImg_description;
              r_data.content.url = g_data.e_txtImg_url;
              r_data.content.image = g_data.e_txtImg_image;

              r_number = r_number + 1;
            } else if (g_data.e_type == 4) {
              // 多图文消息
              r_data.content = g_data.e_txtImgData;
              for (let i = 0; i < g_data.e_txtImgData.length; i++) {
                if (!g_data.e_txtImgData[i].title) {
                  that.$message.warning(`${warning_text}---请输入消息标题`);
                  return;
                } else if (!g_data.e_txtImgData[i].description) {
                  that.$message.warning(`${warning_text}---请输入消息描述`);
                  return;
                } else if (!g_data.e_txtImgData[i].image) {
                  that.$message.warning(`${warning_text}---请选择消息图片`);
                  return;
                } else if (!g_data.e_txtImgData[i].url) {
                  that.$message.warning(`${warning_text}---请输入消息链接URL`);
                  return;
                }
              }

              r_number = r_number + 1;
            } else if (g_data.e_type == 5) {
              // 小程序
              if (!g_data.xcx_title) {
                that.$message.warning(`${warning_text}---请填写小程序消息标题`);
                return;
              } else if (!g_data.xcx_appid) {
                that.$message.warning(`${warning_text}---请填写小程序APPID`);
                return;
              } else if (!g_data.xcx_pagepath) {
                that.$message.warning(`${warning_text}---请填写小程序路径`);
                return;
              } else if (!g_data.xcx_media_url) {
                that.$message.warning(`${warning_text}---请填写消息封面`);
                return;
              }
              r_data.content.title = g_data.xcx_title;
              r_data.content.appid = g_data.xcx_appid;
              r_data.content.pagepath = g_data.xcx_pagepath;
              // r_data.content.thumb_media_id = g_data.xcx_media_id // 可以不传
              r_data.content.thumb_media_id_url = g_data.xcx_media_url;

              r_number = r_number + 1;
            }

            r_arr.push(r_data);
            if (r_number == that.gzhTabData.length) {
              // 保证循环完毕
              resolve("校验成功");
            }
          }
        }
      });

      for_gzh.then((res) => {
        let r_data = {
          message: r_arr,
        };

        that.$emit("follow-handle", r_arr);
      });
    },
    msgHandleCancel() {
      this.msg_modal_visible = false;
      this.msg_modal_loading = false;
      this.msg_preview_loading = false;

      this.pl_gzh_select = false;

      this.e_openid = "";
    },

    addStatusChange(e) {
      // 开启状态
      // this.e_switch = e
      this.gzhTabData[this.gzh_tab_index].contentData.e_switch = e;
    },

    // 图片上传 限制用户上传的图片格式和大小。
    beforeUpload(file) {
      this.e_img_loading = true;
      // this.gzhTabData[this.gzh_tab_index].contentData.e_img_url = ""
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.e_img_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.e_img_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    uploadChange(info, b_index) {
      let that = this;

      that.gzh_tab_index = b_index;

      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        that.e_img_loading = false;

        if (info.file.response) {
          // 图片上传成功，有内容返回
          if (info.file.response.code == 401) {
            that.$message.error(`错误：${info.file.response.msg}`);
            return;
          }
          that.gzhTabData[that.gzh_tab_index].contentData.e_img_url =
            info.file.response.data.url;
          // that.gzhTabData[that.gzh_tab_index].contentData.e_img_media_id = info.file.response.data.path
        } else {
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 图文消息上传
    txtimgBeforeUpload(file) {
      this.e_img_loading = true;
      // this.gzhTabData[this.gzh_tab_index].contentData.e_txtImg_image = ""
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.e_img_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.e_img_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    txtimgUploadChange(info, b_index) {
      let that = this;

      that.gzh_tab_index = b_index;

      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        that.e_img_loading = false;
        // console.log("图片请求done",info);
        if (info.file.response) {
          // 图片上传成功，有内容返回
          if (info.file.response.code == 401) {
            that.$message.error(`错误：${info.file.response.msg}`);
            return;
          }
          // path: "gzh-local-message/OMs8b00Tkja3PVWNSyd5fhH5SfHVdnTCkzFcTtUD.jpg"
          // url: "https://oss.gzlize.com/gzh-local-message/OMs8b00Tkja3PVWNSyd5fhH5SfHVdnTCkz
          let gzh_data = that.gzhTabData[that.gzh_tab_index].contentData;
          if (gzh_data.e_type == 3) {
            // 单图文
            gzh_data.e_txtImg_image = info.file.response.data.url;
            gzh_data.e_txtImg_path = info.file.response.data.path;
            // 编辑操作的时候，替换图片，视图不更新，所以这里处理一下
            that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
            that.$set(
              that.gzhTabData[that.gzh_tab_index],
              "contentData",
              gzh_data
            );
          } else if (gzh_data.e_type == 4) {
            // 多图文
            gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image =
              info.file.response.data.url;
            // 编辑操作的时候，替换图片，视图不更新，所以这里处理一下
            that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
            that.$set(
              that.gzhTabData[that.gzh_tab_index],
              "contentData",
              gzh_data
            );
          } else if (gzh_data.e_type == 5) {
            // 小程序
            gzh_data.xcx_media_url = info.file.response.data.url;
            // gzh_data.xcx_media_id = info.file.response.data.path // 可以不传
            // 编辑操作的时候，替换图片，视图不更新，所以这里处理一下
            that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
            that.$set(
              that.gzhTabData[that.gzh_tab_index],
              "contentData",
              gzh_data
            );
          }
        } else {
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },
    // 新建素材
    addContent(b_item) {
      b_item.contentData.e_txtImgData.push({
        select_status: false,
        title: "",
        description: "",
        url: "",
        image: "",
      });
    },
    // 删除图文-确认按钮
    confirmDelImg(index, b_item) {
      let gzh_data = b_item.contentData;
      // console.log("handle_type",this.handle_type);
      if (this.handle_type == 2) {
        // 表示处于查看详情状态，不能进行操作
        this.$message.warning(
          `当前为查看详情状态，请先点击底部的'编辑模板'按钮，进入编辑状态`
        );
        return;
      }
      if (gzh_data.e_txtImgData.length > 1) {
        if (gzh_data.e_txtImgData[index].select_status) {
          // 为选中状态就不能直接删，因为页面正在显示当前选中的数据
          gzh_data.e_txtImgData[index].select_status = false;
          if (index == 0) {
            // 表示删除第一个
            gzh_data.e_txtImg_index = 0;
            gzh_data.e_txtImgData[index + 1].select_status = true;
          } else if (index == gzh_data.e_txtImgData.length - 1) {
            // 删最后一个
            gzh_data.e_txtImg_index = index - 1;
            gzh_data.e_txtImgData[index - 1].select_status = true;
          } else {
            gzh_data.e_txtImg_index = index - 1;
            gzh_data.e_txtImgData[index - 1].select_status = true;
          }
        }

        // 选中第三个，删除第二个，会报错，因为索引不到，所以要重新调整索引
        if (gzh_data.e_txtImg_index >= index) {
          gzh_data.e_txtImg_index = 0;
          gzh_data.e_txtImgData.forEach((res) => {
            res.select_status = false;
          });
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].select_status = true;
        }

        gzh_data.e_txtImgData.splice(index, 1);
      } else {
        this.$message.warning("不能全部删除");
      }
    },
    // 切换显示的内容
    changeMaterial(item, index, b_item) {
      b_item.contentData.e_txtImgData.forEach((res) => {
        res.select_status = false;
      });
      item.select_status = true;
      b_item.contentData.e_txtImg_index = index;
    },

    // 预览
    sendPreview() {},

    // 裁切图片
    cutCover(b_item, b_index) {

      this.gzh_tab_index = b_index;

      let gzh_data = b_item.contentData;
      // console.log('裁切图片',gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image.split('?'))

      let o_data;
      let f_n = [];
      if (gzh_data.e_type == 4) {
        // 多图文
        // console.log('多图文',gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image.split('?'))
        if (gzh_data.e_txtImg_index == 0) {
          f_n = [23.47, 10];
        } else {
          f_n = [10, 10];
        }
        o_data =
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image.split("?");
      } else if (gzh_data.e_type == 5) {
        // 小程序
        f_n = [5, 4];
        o_data = gzh_data.xcx_media_url.split("?");
      } else {
        // 单图文
        f_n = [10, 10];
        o_data = gzh_data.e_txtImg_image.split("?");
      }
      this.$refs.getCropperImg.cutImgHandle(o_data[0], f_n);
    },

    // 裁切弹窗确认
    cropperOk(img) {
      let that = this;
      let gzh_data = this.gzhTabData[this.gzh_tab_index].contentData;
      if (gzh_data.e_type == 4) {
        // 图文
        gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image = img;
      } else if (gzh_data.e_type == 5) {
        // 小程序卡片
        gzh_data.xcx_media_url = img;
      } else {
        // 单图文
        gzh_data.e_txtImg_image = img;
      }

      that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
      that.$set(that.gzhTabData[that.gzh_tab_index], "contentData", gzh_data);

      this.$refs.getCropperImg.cutHandleCancel();
    },

    // 添加关注后回复
    addFollow() {
      let that = this;
      if (this.gzhTabData.length >= 4 && this.page_type == "follow") {
        this.$message.warning("关注后回复-最多可开启4条消息");
        return;
      }
      if (this.gzhTabData.length >= 5 && this.page_type == "contact") {
        this.$message.warning("客服消息-最多可开启5条消息");
        return;
      }
      let data = [
        {
          contentData: {},
        },
      ];
      data[0].contentData = {
        e_title: "", // 消息名称
        e_send_time: 0, // 推送时机
        e_type: 1, // 消息类型
        e_switch: false, // 开启状态

        e_text_content: "", // 文本消息

        e_img_url: "", // 图片消息，的图片链接
        e_img_media_id: "", // 图片消息，的media_id

        e_txtImg_title: "", // 单图文消息 - 标题
        e_txtImg_description: "", // 单图文消息 - 描述
        e_txtImg_url: "", // 单图文消息 -  跳转链接
        e_txtImg_image: "", // 单图文消息 - 图片oss
        e_txtImg_path: "", // 单图文消息 - 图片地址

        e_txtImgData: [
          {
            select_status: true,
            title: "",
            description: "",
            url: "",
            image: "",
          },
        ], // 多图文素材
        e_txtImg_index: 0,

        xcx_title: "",
        xcx_appid: "",
        xcx_pagepath: "",
        xcx_media_url: "",
        xcx_media_id: "",
      };
      this.gzhTabData = this.gzhTabData.concat(data);
    },
    // 删除关注后回复
    delFollow(b_index) {
      if (this.gzhTabData.length > 1) {
        this.gzhTabData.splice(b_index, 1);
      } else {
        this.$message.warning("不能全部删除");
      }
    },

    campaignNameBlur(e, b_index, type) {
      // console.log("111",e.srcElement.selectionStart);
      this.campaignNameIndex = e.srcElement.selectionStart; // 获取光标所在位置
      this.campaign_type = type;

      this.gzh_tab_index = b_index;
    },
    campaignFormatChar(text_value) {
      // 在光标位置插入文本
      let gzh_data = this.gzhTabData[this.gzh_tab_index].contentData;
      let index = this.campaignNameIndex;
      if (this.campaign_type == 1) {
        // 消息名称
        gzh_data.e_title =
          gzh_data.e_title.slice(0, index) +
          text_value +
          gzh_data.e_title.slice(index);
        this.$refs.focusA[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 2) {
        // 文本消息内容
        gzh_data.e_text_content =
          gzh_data.e_text_content.slice(0, index) +
          text_value +
          gzh_data.e_text_content.slice(index);
        const input = this.$refs.focusB[this.gzh_tab_index];
        // this.$nextTick(() => {
        input.focus();
        // })
      } else if (this.campaign_type == 3) {
        // 单图文-消息标题
        gzh_data.e_txtImg_title =
          gzh_data.e_txtImg_title.slice(0, index) +
          text_value +
          gzh_data.e_txtImg_title.slice(index);
        this.$refs.focusC[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 4) {
        // 单图文-消息描述
        gzh_data.e_txtImg_description =
          gzh_data.e_txtImg_description.slice(0, index) +
          text_value +
          gzh_data.e_txtImg_description.slice(index);
        this.$refs.focusD[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 5) {
        // 单图文-消息链接URL
        gzh_data.e_txtImg_url =
          gzh_data.e_txtImg_url.slice(0, index) +
          text_value +
          gzh_data.e_txtImg_url.slice(index);
        this.$refs.focusE[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 6) {
        // 多图文-消息标题
        gzh_data.e_txtImgData[gzh_data.e_txtImg_index].title =
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].title.slice(0, index) +
          text_value +
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].title.slice(index);
        this.$refs.focusF[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 7) {
        // 多图文-消息描述
        gzh_data.e_txtImgData[gzh_data.e_txtImg_index].description =
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].description.slice(
            0,
            index
          ) +
          text_value +
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].description.slice(
            index
          );
        this.$refs.focusG[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 8) {
        // 多图文-消息链接URL
        gzh_data.e_txtImgData[gzh_data.e_txtImg_index].url =
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].url.slice(0, index) +
          text_value +
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].url.slice(index);
        this.$refs.focusH[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 9) {
        // 小程序标题
        gzh_data.xcx_title =
          gzh_data.xcx_title.slice(0, index) +
          text_value +
          gzh_data.xcx_title.slice(index);
        this.$refs.focusI[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 10) {
        // 小程序APPID
        gzh_data.xcx_appid =
          gzh_data.xcx_appid.slice(0, index) +
          text_value +
          gzh_data.xcx_appid.slice(index);
        this.$refs.focusJ[this.gzh_tab_index].focus();
      } else if (this.campaign_type == 11) {
        // 小程序路径
        gzh_data.xcx_pagepath =
          gzh_data.xcx_pagepath.slice(0, index) +
          text_value +
          gzh_data.xcx_pagepath.slice(index);
        this.$refs.focusK[this.gzh_tab_index].focus();
      }
    },
    setContentData(data) {
      this.gzhTabData = data;
    },
  },
};
</script>

<style scoped>
.msg-cell-title {
  margin-bottom: 10px;
}

.left-box {
  /* padding: 15px; */
  /* border: 1px solid #ccc; */
  position: sticky;
  top: 70px;
  width: 300px;
  background: #fff;
  padding: 23px;
}
.left-box-border {
  border: 2px solid #409eff;
}
.left-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 12px;
}
.left-cell-top {
  position: relative;
  cursor: pointer;
}
.left-cell-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
}
.left-cell-box-boder {
  border-bottom: 1px solid #e8e8e8;
}
.left-cell-img {
  width: 50px;
  height: 50px;
}
.left-cell-operation {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.7);
}
.left-cell-top:hover .left-cell-operation {
  display: flex;
}
.left-cell-box:hover .left-cell-operation {
  display: flex;
}
.left-cell-operation-icon {
  color: #fff;
  font-size: 16px;
}
.left-cell-add {
  text-align: center;
  font-size: 16px;
  padding: 15px 0 5px;
  cursor: pointer;
}

/* 图片裁切 */
.cover-handle {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* display: flex; */
  align-items: center;
  justify-content: space-around;
}
.cover-box:hover .cover-handle {
  display: flex;
}

.type-3:hover .cover-handle {
  display: flex;
}

.add-button {
  cursor: pointer;
  display: inline-block;
  background-color: #e7e7e7;
  padding: 10px 20px;
  margin: auto;
}
</style>
